(ns kyber.kyber-db.hr-manager-report-learner-data)

(defn ->ident-key
  [{activity-uuid :activity/uuid learner-uuid :external-user/id}]
  (str "activity-" activity-uuid "_learner-" learner-uuid))

(def model
  {:ident-key ->ident-key})
